document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    const originalSlides = Array.from(carousel.querySelectorAll('.custom-carousel__slide'));

    if (!track || originalSlides.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    const slideCount = originalSlides.length;
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[slideCount - 1].cloneNode(true);
    track.insertBefore(lastClone, originalSlides[0]);
    track.appendChild(firstClone);

    let index = 1;

    const viewport = carousel.querySelector('.custom-carousel__viewport');

    const slidesAll = () => Array.from(track.querySelectorAll('.custom-carousel__slide'));

    const warmImages = () => {
      const slides = slidesAll();
      // 预热：当前、下一张、上一张（含 clone 的 index）
      [index, index + 1, index - 1].forEach(i => {
        const s = slides[i];
        if (!s) return;
        const img = s.querySelector('img[data-carousel-img], img');
        if (!img) return;

        img.loading = 'eager';
        img.decoding = 'async';
        if (img.decode) img.decode().catch(() => {});
      });
    };

    const setTransform = () => {
      const w = viewport.getBoundingClientRect().width; // 可能是小数
      const x = Math.round(w * index);                  // 强制对齐到整数像素
      track.style.transform = `translate3d(-${x}px, 0, 0)`;
      warmImages();
    };
    const jumpTo = (newIndex) => {
      track.style.transition = 'none';
      index = newIndex;
      setTransform();
      // force reflow to apply transition reset
      void track.offsetHeight;
      track.style.transition = '';
      warmImages();
    };

    let startX = 0;
    let startY = 0;
    let isSwiping = false;

    const onTouchStart = (event) => {
      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isSwiping = false;
    };

    const onTouchMove = (event) => {
      if (event.touches.length > 1) return;
      const touch = event.touches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;

      if (!isSwiping) {
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
          isSwiping = true;
        } else {
          return;
        }
      }

      event.preventDefault();
    };

    const onTouchEnd = (event) => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const threshold = 40;

      if (Math.abs(deltaX) < threshold) return;

      if (deltaX > 0) {
        index -= 1;
      } else {
        index += 1;
      }
      setTransform();
    };

    prevBtn.addEventListener('click', () => {
      index -= 1;
      setTransform();
    });

    nextBtn.addEventListener('click', () => {
      index += 1;
      setTransform();
    });

    track.addEventListener('transitionend', () => {
      if (index === 0) {
        jumpTo(slideCount);
      }
      if (index === slideCount + 1) {
        jumpTo(1);
      }
    });

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd, { passive: true });

    setTransform();
  });
});
